import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { NotificationService } from '@shared/services';

import { MessagesActions } from './messages.actions';

@Injectable()
export class MessagesEffects {
  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
  ) {}

  errorNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(MessagesActions.displayError),
        map((notification) => this.notificationService.displayError(notification.message, notification.title)),
      );
    },
    { dispatch: false },
  );

  successNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(MessagesActions.displaySuccess),
        map((notification) => this.notificationService.displaySuccess(notification.message, notification.title)),
      );
    },
    { dispatch: false },
  );

  warningNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(MessagesActions.displayWarning),
        map((notification) => this.notificationService.displayWarning(notification.message, notification.title)),
      );
    },
    { dispatch: false },
  );
}
